import React, { useContext, useState } from "react";
import {
  ManageTransactionLayout,
  SearchDropdownWithAPI,
  RejectRequestModal,
  SearchableList,
  FieldDropSide,
  WithDrawalApprovalCard,
  DraftCard,
  DeleteThisRequestModel,
  DraftCardForWithdrawal,
  LoaderWrapper,
  Link,
  DraftCardForLoan,
} from "../../../components";
import { Formik, Field } from "formik";

import { Button, Form, Row, Col, Toast } from "react-bootstrap";
import FilterPill from "../FilterPill/FilterPill";
import {
  FLOW_TYPES,
  formFields,
  getAdvancedPathWithParam,
  manageTransactionFormNames,
  RECORDS_TO_FETCH,
  MANAGE_CENSUS_ROUTES,
  ROUTES,
  MANAGE_DISTRIBUTION_ROUTES,
} from "../../../utils";
import Logo from "../../../assets/empty-draft.svg";
import { useDeepEffect, useRequest } from "../../../abstracts";
import {
  getDraftWithdrawalCount,
  getDraftLoanCount,
  getDraftRolloverinCount,
  getDraftWithdrawalEmployee,
  getDraftLoanEmployee,
  getDraftRolloverinEmployee,
  getEmployeeCensusInformation,
  getLoanApprovalSearchinEmployee,
} from "../../../services";
import InfiniteScroll from "react-infinite-scroller";
import TransactionFilterCard from "../TransactionFilterCard";
import { manageTransactionStore } from "../../../contexts";
import { get } from "lodash";
const initialValues = {
  Withdrawals: {
    userId: 1,
    searchString: "",
    from: 0,
    offset: RECORDS_TO_FETCH,
    orderBy: 1,
  },
  Rolloverin: {
    search: "",
    isAscending: true,
    from: 0,
    offset: RECORDS_TO_FETCH,
  },
  Loans: {
    search: "",
    isAscending: true,
    from: 0,
    offset: RECORDS_TO_FETCH,
  },
};
const buttons = [
  {
    label: "New request",
    variant: "primary",
    type: "button",
    flow: [FLOW_TYPES.ADD, FLOW_TYPES.EDIT, FLOW_TYPES.SAVE],
    // link: getAdvancedPathWithParam({
    //   path: MANAGE_TRADE_ROUTES.ADD_CUSTODIAN,
    //   pathParam: [FLOW_TYPES.SAVE],
    // }),
  },
];

const PendingDraft = (props) => {
  const [modal, setShowModal] = useState(false);
  const { history } = props;
  // const [isModalOpen,setIsModalOpen] = useState(false)
  const [listEmployee, setListEmployee] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [filter, setfilter] = useState("Withdrawals");
  const formName = manageTransactionFormNames.MANAGE_DRAFT;
  const fields = formFields[formName];
  const [employeeRolloverin, setEmployeeRolloverin] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteEmployee, setDeleteEmployee] = useState(listEmployee);
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [append, setAppend] = useState(false);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [empName, setEmpName] = useState(null);

  const [WithdrawalDraftCount, setWithdrawalDraftCount] = useState();
  const [RollOverinDraftCount, setRollOverinDraftCount] = useState();
  const [LoanDraftCount, setLoanDraftCount] = useState();
  const [dataLoad, setDataLoad] = useState();

  useDeepEffect(() => {
    getDraftWithdrawalCount(1).then((res) => {
      setWithdrawalDraftCount(res);
    });
    getDraftRolloverinCount().then((res) => {
      setRollOverinDraftCount(res);
    });
    getDraftLoanCount().then((res) => {
      setLoanDraftCount(res);
    });
  }, [toggle]);

  // const { response: WithdrawalDraftCount, loading: dataLoad } = useRequest({
  //   method: getDraftWithdrawalCount,
  //   payload: 1,
  //   defaultResponse: [],
  // });

  // const { response: LoanDraftCount } = useRequest({
  //   method: getDraftLoanCount,
  //   defaultResponse: [],
  // });

  // const { response: RollOverinDraftCount } = useRequest({
  //   method: getDraftRolloverinCount,
  //   defaultResponse: [],
  // });

  const pendingApproval = [
    {
      label: "Withdrawals",
      count: WithdrawalDraftCount,
    },
    {
      label: "Loans",
      count: LoanDraftCount,
    },
    {
      label: "Rolloverin",
      count: RollOverinDraftCount,
    },
  ];

  const [apiRequest, setApiRequest] = useState(initialValues.Withdrawals);

  useDeepEffect(() => {
    if (!append) {
      setDataLoad(true);
    }
    setIsLoading(true);
    if (filter === "Rolloverin") {
      getDraftRolloverinEmployee(apiRequest)
        .then((response) => {
          setDataLoad(false);
          setTotalEmployees(response.count);
          if (
            response?.rolloverInRequestListInProgress?.length < RECORDS_TO_FETCH
          )
            setStopInfiniteScroll(true);
          if (append) {
            setListEmployee((listEmployee) => {
              return [
                ...listEmployee,
                ...response?.rolloverInRequestListInProgress,
              ];
            });
          } else {
            setListEmployee(response?.rolloverInRequestListInProgress);
            setIsLoading(false);
            setStopInfiniteScroll(false);
          }

          // dispatch(
          //   setManagePageLevelData({
          //     formName: formName,
          //     fieldData: request,
          //   })
          // );
        })
        .catch((error) => {
          // Handle Errors
          setIsLoading(false);
        });
    } else if (filter === "Loans") {
      getLoanApprovalSearchinEmployee(apiRequest)
        .then((response) => {
          //set the count after getting response count
          setDataLoad(false);
          setTotalEmployees(response.count);
          if (
            response?.loanInProgressDetailsAwaitingForApproval?.length <
            RECORDS_TO_FETCH
          )
            setStopInfiniteScroll(true);

          if (append) {
            setListEmployee((listEmployee) => {
              return [
                ...listEmployee,
                ...response?.loanInProgressDetailsAwaitingForApproval,
              ];
            });
          } else {
            setListEmployee(response?.loanInProgressDetailsAwaitingForApproval);
            setIsLoading(false);
            setStopInfiniteScroll(false);
          }
          // dispatch(
          //   setManagePageLevelData({
          //     formName: formName,
          //     fieldData: request,
          //   })
          // );
        })
        .catch((error) => {
          // Handle Errors
          setIsLoading(false);
        });
    } else if (filter === "Withdrawals") {
      getDraftWithdrawalEmployee(apiRequest)
        .then((response) => {
          //set the count after getting response count
          getEmployeeCensusInformation(response.employeeId).then(
            (res) => {}
            //setEmpName(res.firstName + " " + res.middleName + " " + res.lastName);
          );
          setDataLoad(false);
          setTotalEmployees(response.count);
          if (response?.withdrawalRequests?.length < RECORDS_TO_FETCH)
            setStopInfiniteScroll(true);

          if (append) {
            setListEmployee((listEmployee) => {
              return [...listEmployee, ...response?.withdrawalRequests];
            });
          } else {
            setListEmployee(response?.withdrawalRequests);
            setIsLoading(false);
            setStopInfiniteScroll(false);
          }
          // dispatch(
          //   setManagePageLevelData({
          //     formName: formName,
          //     fieldData: request,
          //   })
          // );
        })
        .catch((error) => {
          // Handle Errors
          setIsLoading(false);
        });
    } else {
      setListEmployee([]);
    }
  }, [filter, apiRequest, toggle]);

  return (
    <ManageTransactionLayout
      layoutHeader="Withdrawal Requests In-Progress"
      // buttons={buttons}
      // pageFlow={FLOW_TYPES.ADD}
    >
      {/* <RejectRequestModal
        show={modal}
        onHide={() => setShowModal(false)}
      ></RejectRequestModal> */}
      <DeleteThisRequestModel
        filter={filter}
        show={modal}
        deleteEmployee={deleteEmployee}
        setDeleteEmployee={setDeleteEmployee}
        setShowModal={setShowModal}
        onHide={() => setShowModal(false)}
        listEmployee={listEmployee}
        setListEmployee={setListEmployee}
        toggle={toggle}
        setToggle={setToggle}
        setAppend={setAppend}
        empName={empName}
      ></DeleteThisRequestModel>

      <LoaderWrapper>
        {LoanDraftCount > 0 ||
        WithdrawalDraftCount > 0 ||
        RollOverinDraftCount > 0 ||
        true ? (
          <div className="h-100">
            <TransactionFilterCard
              append={append}
              setAppend={setAppend}
              fields={fields}
              apiRequest={apiRequest}
              listEmployee={listEmployee}
              setListEmployee={setListEmployee}
              setApiRequest={setApiRequest}
              filter={filter}
            />

            <div className="d-flex column">
              {pendingApproval.map((pending) => {
                return (
                  <FilterPill
                    filter={filter}
                    setfilter={setfilter}
                    pendingApproval={pending}
                    apiRequest={apiRequest}
                    setApiRequest={setApiRequest}
                    onChange={() => {
                      setfilter(pending.label);
                      setAppend(false);
                      setApiRequest(initialValues[pending.label]);
                    }}
                    // setMethod={setMethod}
                  />
                );
              })}
            </div>
            <br></br>

            {filter != "Loans" && (
              <div className="d-flex flex-row justify-content-end text-right records-text ft-14 mr-3">
                {totalEmployees} Requests
              </div>
            )}

            <div style={{ height: "59%", overflow: "scroll" }}>
              <LoaderWrapper isLoading={dataLoad}>
                <InfiniteScroll
                  style={{ maxHeight: "100%" }}
                  pageStart={0}
                  loadMore={() => {
                    setAppend(true);
                    setApiRequest((apiRequest) => {
                      return {
                        ...apiRequest,
                        from: listEmployee?.length,
                      };
                    });
                  }}
                  hasMore={!stopInfiniteScroll}
                  initialLoad={false}
                  threshold={100}
                  useWindow={false}
                  loader={
                    listEmployee?.length != 0 && (
                      <div className="loader" key={0}>
                        {/* Loading ... */}
                      </div>
                    )
                  }
                >
                  {filter === "Rolloverin" &&
                    listEmployee?.map((ti) => {
                      return (
                        <div
                          style={{
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                        >
                          <DraftCard
                            filter={filter}
                            setDeleteEmployee={setDeleteEmployee}
                            setShowModal={setShowModal}
                            employeeRolloverin={ti}
                            onClickOfCard={() =>
                              history.push(
                                getAdvancedPathWithParam({
                                  path: `${MANAGE_CENSUS_ROUTES.ROLLOVER_REQUEST}`,
                                  pathParam: [
                                    FLOW_TYPES.EDIT,
                                    ti.employeeId,
                                    ti.id,
                                    1,
                                  ],
                                })
                              )
                            }
                          />
                        </div>
                      );
                    })}

                  {filter === "Loans" &&
                    listEmployee?.map((ti) => {
                      return (
                        <div
                          style={{
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                        >
                          <DraftCardForLoan
                            filter={filter}
                            setDeleteEmployee={setDeleteEmployee}
                            setShowModal={setShowModal}
                            employeeRolloverin={ti}
                            onClickOfCard={() =>
                              history.push(
                                getAdvancedPathWithParam({
                                  path: MANAGE_DISTRIBUTION_ROUTES.LOAN_REQUEST,
                                  pathParam: [
                                    FLOW_TYPES.EDIT,
                                    ti.employeeId,
                                    ti.id,
                                    5,
                                  ],
                                })
                              )
                            }
                          />
                        </div>
                      );
                    })}

                  {filter === "Withdrawals" &&
                    listEmployee?.map((ti) => {
                      return (
                        <div
                          style={{
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                        >
                          <DraftCardForWithdrawal
                            filter={filter}
                            setDeleteEmployee={setDeleteEmployee}
                            setShowModal={setShowModal}
                            employeeRolloverin={ti}
                            onClickOfCard={() =>
                              history.push(
                                getAdvancedPathWithParam({
                                  path: `${MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_REQUEST}`,
                                  pathParam: [
                                    FLOW_TYPES.EDIT,
                                    ti.employeeId,
                                    ti.withdrawalRequestId,
                                    4,
                                  ],
                                })
                              )
                            }
                          />
                        </div>
                      );
                    })}
                </InfiniteScroll>
              </LoaderWrapper>
            </div>
          </div>
        ) : (
          <div>
            <div className="d-flex justify-content-center">
              <img
                className="img"
                style={{
                  width: "494px",
                  height: "369px",
                }}
                src={Logo}
              />
            </div>

            <p
              style={{
                textAlign: "center",
                justifyContent: "center",
                fontWeight: "500",
                fontSize: "24px",
              }}
            >
              Hmm...
            </p>
            <p
              style={{
                textAlign: "center",
                justifyContent: "center",
                fontWeight: "500",
                fontSize: "24px",
              }}
            >
              No requests-in progress
            </p>
            <p
              style={{
                textAlign: "center",
                justifyContent: "center",
                fontWeight: "500",
                fontStyle: "normal",
                fontWeight: "600",
                fontSize: "24px",
              }}
            >
              But, You can make a request
            </p>
          </div>
        )}
      </LoaderWrapper>
    </ManageTransactionLayout>
  );
};

export default PendingDraft;
